import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    totalAmount: Number,
  };

  #currentAmount;

  connect() {
    this.#currentAmount = 0;
  }

  update() {
    this.#currentAmount += 1;
    this.element.innerText = `${this.#currentAmount} out of ${
      this.totalAmountValue
    } items uploaded...`;
  }
}
